import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { text: String, timeout: { type: Number, default: 2000 } }
  static targets = ['default', 'success']

  copy() {
    navigator.clipboard.writeText(this.textValue)
    this.defaultTarget.classList.add('hidden')
    this.successTarget.classList.remove('hidden')

    clearTimeout(this.resetTimeout)
    this.resetTimeout = setTimeout(() => {
      this.defaultTarget.classList.remove('hidden')
      this.successTarget.classList.add('hidden')
    }, this.timeoutValue)
  }

  disconnect() {
    clearTimeout(this.resetTimeout)
  }
}
